import React from 'react'
import { connect } from 'react-redux'
import {Link } from 'react-router-dom'
import {Navbar,Nav, NavItem, NavDropdown, MenuItem, Glyphicon} from 'react-bootstrap'
import {withRouter} from 'react-router-dom'
import {SITE_NAME, MEDIA_URL} from '../constants'
import {getUserPhone, getUserProfile, getUserSettings} from '../storage'
import styled from 'styled-components';
const nNavs = {

  "items": {path:'/items', label:'Items'},
  "services": {path:'/services', label:'Services'},
  "brands": {path:'/brands', label:'Brands'},
  "units": {path:'/units', label:'Units'},
  "discounts": {path:'/discounts', label:'Discounts'},

  "invoices": {path:'/invoices', label:'Invoices'},
  "purchases": {path:'/purchases', label:'Purchases'},
  "receipts": {path:'/receipts', label:'Receipts'},
  "payments":{path:'/payments', label:'Payments'},
  "expenses":{path:'/expenses', label:'Expenses'},

  "credit_notes":{path:'/credit_notes', label:'Credit Notes'},
  "debit_notes":{path:'/debit_notes', label:'Debit Notes'},

  "suppliers":{path:'/suppliers', label:'Suppliers'},
  "clients":{path:'/clients', label:'Clients'},
  "departments":{path:'/costcenters', label:'Cost Centers'},

  "day_book":{path:'/reports/day_book', label:'Day Book', parent: '/reports'},
  "gstr_reports":{path:'/reports/gstr_reports', label:'GSTR Reports', parent: '/reports'},
  "brand_sale_report":{path:'/reports/brand_sale_report', label:'Brand Sale Report', parent: '/reports'},

  "profile":{path:'/edit_company_profile', label:'Profile'},
  "settings":{path:'/edit_settings', label:'Settings'},
  "documentation":{path:'/documentation/', label:'Help Center'},
  "logout":{path:'/logout', label:'Logout'}
}
const navs = [

{path:'/items', label:'Items'},
{path:'/services', label:'Services'},
{path:'/brands', label:'Brands'},
{path:'/units', label:'Units'},
{path:'/discounts', label:'Discounts'},

{path:'/invoices', label:'Invoices'},
{path:'/purchases', label:'Purchases'},
{path:'/receipts', label:'Receipts'},
{path:'/payments', label:'Payments'},
{path:'/expenses', label:'Expenses'},

{path:'/credit_notes', label:'Credit Notes'},
{path:'/debit_notes', label:'Debit Notes'},

{path:'/suppliers', label:'Suppliers'},
{path:'/clients', label:'Clients'},
{path:'/costcenters', label:'Cost Centers'},

{path:'/reports/day_book', label:'Day Book', parent: '/reports'},
{path:'/reports/gstr_reports', label:'GSTR Reports', parent: '/reports'},
{path:'/reports/brand_sale_report', label:'Brand Sale Report', parent: '/reports'},

{path:'/edit_company_profile', label:'Profile'},
{path:'/edit_settings', label:'Settings'},
{path:'/documentation/', label:'Help Center'},
{path:'/logout', label:'Logout'}
]

class AppHeader extends React.Component {

  constructor(props) {
    super(props)
    this.getUserDetails = this.getUserDetails.bind(this)
    this.state = {current_nav_item: this.props.location.pathname}
    this.setCurrentNavItem = this.setCurrentNavItem.bind(this)
    this.getItemDropDownClass = this.getItemDropDownClass.bind(this)
    this.getReportDropDownClass = this.getReportDropDownClass.bind(this)
    this.getOptionsDropDownClass = this.getOptionsDropDownClass.bind(this)
    this.getInvoiceDropDownClass = this.getInvoiceDropDownClass.bind(this)
    this.getReturnDropDownClass = this.getReturnDropDownClass.bind(this)
    this.openNew = this.openNew.bind(this)
    this.state ={
      helprequired:false

    }
    this.handleChat = this.handleChat.bind(this)
    this.navIndex = 0
  }


  handleChat(e) {

    e.preventDefault()
    this.setState({helprequired:true})
    sessionStorage.helprequired = true;
  }

  openNew(navitem) {
    let win = window.open("https://www.goodsbill.com/documentation/", '_blank');
    win.focus();
  }

  setCurrentNavItem(navitem) {
    this.props.history.push(navitem)
    this.setState({current_nav_item: navitem})
  }
  getUserDetails() {

  }
  getItemDropDownClass() {

    if ( this.state.current_nav_item === nNavs.items.path
      || this.state.current_nav_item === nNavs.services.path
      ||  this.state.current_nav_item === nNavs.brands.path
      ||  this.state.current_nav_item === nNavs.units.path
      ||  this.state.current_nav_item === nNavs.discounts.path
    ) {
      return "active"
    }
  }
  getInvoiceDropDownClass() {
    if ( this.state.current_nav_item === nNavs.invoices.path
      || this.state.current_nav_item === nNavs.purchases.path
      || this.state.current_nav_item === nNavs.receipts.path
      || this.state.current_nav_item === nNavs.payments.path
      || this.state.current_nav_item === nNavs.expenses.path

    ) {
      return "active"
    }
  }
  getReturnDropDownClass() {
    if ( this.state.current_nav_item ===nNavs.credit_notes.path
      || this.state.current_nav_item === nNavs.debit_notes.path

    ) {
      return "active"
    }
  }
  getReportDropDownClass() {
   if ( this.state.current_nav_item === nNavs.day_book.path||
     this.state.current_nav_item === nNavs.gstr_reports.path ||
     this.state.current_nav_item === nNavs.brand_sale_report.path

   ) {
     return "active"
   }
  }
  getClientDropDownClass = ()=> {
   if ( this.state.current_nav_item === nNavs.clients.path||
     this.state.current_nav_item === nNavs.departments.path
   ) {
     return "active"
   }
  }
  getOptionsDropDownClass() {
   if ( this.state.current_nav_item === nNavs.profile.path
     || this.state.current_nav_item === nNavs.settings.path
     || this.state.current_nav_item === nNavs.documentation.path
     || this.state.current_nav_item === nNavs.logout.path) {
     return "active"
   }
  }
  render() {

    let userphone = getUserPhone()
    let settings = getUserSettings()
    let profile = getUserProfile()
    let logo
    if(profile.logo && profile.logo.length) {
    logo = <div style={{display:'inline-block', width:30, height:30, borderRadius:'50%',
      backgroundRepeat:'no-repeat',
      verticalAlign:'middle',
      backgroundImage:`url(${MEDIA_URL+profile.logo})`, backgroundSize:'contain'}}></div>
    }

    let clientsNav
    let inverseNav = false
    let siteName = SITE_NAME
    if(settings.options && settings.options.enable_departments) {
      siteName = <span>GoodsBill <small style={{fontSize:14,}}>cms</small></span>
      inverseNav = true
      clientsNav = <NavItem onClick={e=>{this.setCurrentNavItem(nNavs.departments.path)}}
        className={this.state.current_nav_item === nNavs.departments.path ? "active": ""}>{ nNavs.departments.label}</NavItem>
    }
    else {
      clientsNav = <NavItem onClick={e=>{this.setCurrentNavItem(nNavs.clients.path)}}
        className={this.state.current_nav_item === nNavs.clients.path ? "active": ""}>{ nNavs.clients.label}</NavItem>
    }


    return <Navbar  collapseOnSelect staticTop fluid  >
  <Navbar.Header>
    <Navbar.Brand>
      <Link to="/" onClick={e=>{this.setCurrentNavItem("/")}}>{siteName}</Link>
    </Navbar.Brand>
    <Navbar.Toggle />
  </Navbar.Header>
  <Navbar.Collapse>
    <Nav>
      <NavDropdown eventKey={1}  title="Item" id="items-nav-dropdown"
          className={this.getItemDropDownClass()}>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.items.path)}}
            className={this.state.current_nav_item === nNavs.items.path ? "active": ""}>{ nNavs.items.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.services.path)}}
            className={this.state.current_nav_item === nNavs.services.path ? "active": ""}>{ nNavs.services.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.brands.path)}}
            className={this.state.current_nav_item === nNavs.brands.path ? "active": ""}>{ nNavs.brands.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.units.path)}}
              className={this.state.current_nav_item === nNavs.units.path ? "active": ""}>{ nNavs.units.label}</MenuItem>
            <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.discounts.path)}}
                  className={this.state.current_nav_item === nNavs.discounts.path ? "active": ""}>{ nNavs.discounts.label}</MenuItem>
      </NavDropdown>

      <NavDropdown eventKey={2}  title="Invoice" id="invoice-nav-dropdown"
          className={this.getInvoiceDropDownClass()}>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.invoices.path)}}
            className={this.state.current_nav_item === nNavs.invoices.path ? "active": ""}>{ nNavs.invoices.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.purchases.path)}}
            className={this.state.current_nav_item === nNavs.purchases.path ? "active": ""}>{ nNavs.purchases.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.receipts.path)}}
            className={this.state.current_nav_item === nNavs.receipts.path ? "active": ""}>{ nNavs.receipts.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.payments.path)}}
            className={this.state.current_nav_item === nNavs.payments.path ? "active": ""}>{ nNavs.payments.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.expenses.path)}}
              className={this.state.current_nav_item === nNavs.expenses.path ? "active": ""}>{ nNavs.expenses.label}</MenuItem>
      </NavDropdown>
      <NavDropdown eventKey={3}  title="Credit" id="invoice-nav-dropdown"
          className={this.getReturnDropDownClass()}>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.credit_notes.path)}}
            className={this.state.current_nav_item === nNavs.credit_notes.path ? "active": ""}>{ nNavs.credit_notes.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.debit_notes.path)}}
            className={this.state.current_nav_item === nNavs.debit_notes.path ? "active": ""}>{ nNavs.debit_notes.label}</MenuItem>
      </NavDropdown>

      <NavItem onClick={e=>{this.setCurrentNavItem(nNavs.suppliers.path)}} className={this.state.current_nav_item === nNavs.suppliers.path ? "active": ""}>{ nNavs.suppliers.label}</NavItem>
      {clientsNav}
      <NavDropdown eventKey={4}  title="Reports" id="reports-nav-dropdown"
          className={this.getReportDropDownClass()}>

          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.day_book.path)}}
            className={this.state.current_nav_item === nNavs.day_book.path ? "active": ""}>{ nNavs.day_book.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.gstr_reports.path)}}
            className={this.state.current_nav_item === nNavs.gstr_reports.path ? "active": ""}>{ nNavs.gstr_reports.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.brand_sale_report.path)}}
              className={this.state.current_nav_item === nNavs.brand_sale_report.path ? "active": ""}>{ nNavs.brand_sale_report.label}</MenuItem>

      </NavDropdown>
    </Nav>

    <Nav pullRight>
      <NavItem disabled className="hidden-sm hidden-xs">{logo} {profile.company_name}</NavItem>
      <NavDropdown eventKey={4}  title={userphone} id="options-nav-dropdown"
          className={this.getOptionsDropDownClass()}>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.profile.path)}}
            className={this.state.current_nav_item === nNavs.profile.path ? "active": ""}>{ nNavs.profile.label}</MenuItem>
          <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.settings.path)}}
            className={this.state.current_nav_item === nNavs.settings.path ? "active": ""}>{ nNavs.settings.label}</MenuItem>
          <MenuItem onClick={e=>{this.openNew(nNavs.documentation.path)}}
              className={this.state.current_nav_item === nNavs.documentation.path ? "active": ""}>{ nNavs.documentation.label}</MenuItem>
            <MenuItem onClick={e=>{this.setCurrentNavItem(nNavs.logout.path)}}
              className={this.state.current_nav_item === nNavs.logout.path ? "active": ""}>{ nNavs.logout.label}</MenuItem>
      </NavDropdown>

    </Nav>
  </Navbar.Collapse>

</Navbar>
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.authReducer,
      nav: state.navReducer
  }
}
export default connect(mapStateToProps)(withRouter(AppHeader))



// WEBPACK FOOTER //
// ./src/components/appheader.js